module.exports = __webpack_public_path__ + "static/media/logo-vigaflow.d7f04184.svg";